<mat-dialog-content class="conteudo">
  <!-- O botão X fica sobre a linha do título "Similares" (título do próprio app-lista-similares) -->
  <button class="fechar" mat-icon-button type="button" matTooltip="Fechar" (click)="fechar()">
    <mat-icon>close</mat-icon>
  </button>
  <app-lista-similares #listaSimilares [tipo]="data.tipo ?? 'similares'" [cdItemAtual]="data.cdItem" (selecionado)="abrirItemDetalhado($event)">
  </app-lista-similares>
</mat-dialog-content>
